/**
 * Returns true if `route` is a safe in-app path for process-completion navigation.
 * Rejects protocol-relative URLs, traversal, and non-property routes (defense in depth).
 *
 * @param {unknown} route
 * @returns {boolean}
 */
export function isAllowedProcessNotificationRoute(route) {
  if (typeof route !== "string" || route.length === 0) return false;
  if (!route.startsWith("/")) return false;
  if (route.startsWith("//")) return false;
  if (route.includes("..")) return false;
  // Canonical property detail: `/property/<id>`. `/properties/<id>` still allowed for legacy persisted inbox rows.
  return /^\/(?:property|properties|campaigns)\/[^/?#]+$/.test(route);
}
